import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./graph-animation-info-box.style";
import { useChartTimeline, } from "ui/components/elements/chart/chart-timeline";
import { partSecuredColor, energySavingColor, } from "store/system-performance/types";
import { useIsAtAtmosphere, useReachedVacuumThresholds, } from "hooks/graph-panel/use-current-vacuum-level";
export var GraphAnimationInfoBox = function () {
    var timeline = useChartTimeline();
    if (!timeline)
        return null;
    return _jsx(GraphAnimationInfoBoxContent, { timeline: timeline });
};
var GraphAnimationInfoBoxContent = function (_a) {
    var timeline = _a.timeline;
    var _b = useReachedVacuumThresholds(), reachedPS = _b.reachedPS, reachedES = _b.reachedES;
    // ATM is on at the start (before vacuum builds) and again once the part is
    // released. The return edge is glued to the cup-release event so it matches
    // the ATM reference line on the charts; tracking the governing pump instead
    // lit it ~0.02s early, since the pump reaches blow-off overpressure before the
    // cups release the part. See useIsAtAtmosphere.
    var isAboveAtm = useIsAtAtmosphere();
    var hasES = timeline.delayToEnergySave !== undefined;
    return (_jsxs(Styled.Indicators, { children: [_jsx(Styled.Indicator, { color: partSecuredColor, active: reachedPS, children: "PS" }), hasES && (_jsx(Styled.Indicator, { color: energySavingColor, active: reachedES, children: "ES" })), _jsx(Styled.Indicator, { color: "#27AE60", active: isAboveAtm, children: "ATM" })] }));
};
